// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__15kP2","header":"styles_header__lw98_"};